;
(function ($) {
	"use strict";
	window.FilesControls = function (options) {
		this._init(options);
	};

	$.extend(FilesControls.prototype, {
		$options: {
			imageLoading: false,
			photoUseCamera: false,
			sessionId: null,
			resourceId: null,
			resourceType: null,
			rz: [],
		},

		//=====================================================================
		// IMAGES
		//=====================================================================

		/**
		 * 
		 * @param useCamera
		 */
		addPhoto: function (useCamera) {
			var $template = $('#addedPhotoTemplate').clone(),
				$addedPhotosDiv = $('#addedPhotos'),
				$column = $('#imagesColumn' + ($addedPhotosDiv.find('.js-added-photo').length % 2)),
				app = this,
				camera = useCamera ? "capture='camera'" : "";
			
			app.$options.photoUseCamera = useCamera;
			
			$template.attr('id', '');
			$template.removeClass('template');

			var templateHtml = $template.html();
			templateHtml = templateHtml.replace(/\{\{id\}\}/g, "{{tmpid}}");
			templateHtml = templateHtml.replace(/\{\{capture_camera\}\}/g, camera);
			$template.html(templateHtml);

			$column.append($template);

			app.$options.imageLoading = true;
			var $input = $template.find('input.add-image-input');
			$input.trigger('click');

			$(document).on('focus', 'body', function () {
				window.setTimeout( function () {
					if (app.$options.imageLoading) {
						app.uploadImage($template, $input);
					}
				}, 1000);
			});
		},

		/**
		 * 
		 * @param $wrapper
		 * @param $input
		 */
		uploadImage: function ($wrapper, $input) {
			var app = this,
				files = $input.prop('files'),
				reader = new FileReader(),
				lpCheckbox = $('#enableDetectionLP').get(0),
				detectLp = lpCheckbox ? lpCheckbox.checked : false;
			app.$options.imageLoading = false;

			reader.addEventListener("load", function () {
				var data = reader.result;
				var tmpData = reader.result.split(',')[1];
				var fullExif = null;
				try {
					fullExif = window.readEXIFfromB64String(tmpData);
					if (!fullExif) {
						fullExif = null;
					}
				} catch (e) {
					console.warn(e.message);
				}
				
				$.ajax({
					url: route('wrongDoings.uploadImage', {}),
					method: 'post',
					data: {
						file: data,
						resourceId: app.$options.resourceId,
						resourceType: app.$options.resourceType,
						sessionId: app.$options.sessionId,
						detectLp: detectLp,
						exif: fullExif,
					},
					timeout: 60000,
					success: function (response) {
						if (('success' in response) && response.success) {
							app.uploadImageSuccess(response, $wrapper);
							$input.remove();
						} else {
							if ('message' in response) {
								bootbox.alert(response.message);
							}
							$input.closest('.js-added-photo').remove();
						}
					},
					error: function (e) {
						console.log('error', e);
						$input.closest('.js-added-photo').remove();
					},
				});
				
			}, false);
			
			if (files && (files.length > 0)) {
				for (var i = 0; i < files.length; ++i) {
					reader.readAsDataURL(files[i]);
				}
				
				if (app.$options.photoUseCamera && window.$wdEventCommon) {
					window.$wdEventCommon.setSheriffDeviceInfo('photoTaken', true);
				}
			} else {
				$input.closest('.js-added-photo').remove();
			}

			$(document).off('focus', 'body');
		},

		uploadImageSuccess: function (response, $wrapper) {
			var app = this,
				$controls = $wrapper.find('.js-change-display-on-announcement'),
				$soaaInput = $wrapper.find('.input-image-soaa'),
				$preview = $wrapper.find(".preview-tpl"),
				$previewSm = $wrapper.find(".preview-sm-tpl"),
				$removeButton = $wrapper.find(".js-remove-image");

			$preview.attr('src', response.link + "/" + response.tn)
				.data('previewSrc', response.link)
				.removeClass('preview-tpl')
				.attr('id', 'preview-'+response.id);
			
			$previewSm.attr('src', response.link + "/" + response.tn)
				.removeClass('preview-sm-tpl')
				.attr('id', 'preview-'+response.id);
			
			
			$controls.data('id', '#soaa-'+response.id);
			$soaaInput.attr('name', "images["+response.id+"][soa]").attr('id', 'soaa-'+response.id);

			$removeButton.attr('id', "img-"+response.id);
			
			$wrapper.removeClass('loading');
			
			var $links = $('#wrongDoingsByRzLinks'),
				$table = $links.find('table.table > tbody');
			if (('rz' in response) && response.rz) {
				$.each(response.rz, function (rzc, data) {
					const regex = /(.*) ; (.*)/i;
					const found = rzc.match(regex);
					var rz = rzc;
					var country = null;
					if (found) {
						rz = found[1];
						country = found[2];
					}
					
					//Find and increment, or append
					var exists = app.$options.rz.find(function (obj) { return obj.rz === rz; });
					if (exists) {
						exists.cnt++;
					} else {
						app.$options.rz.push({ 'rz': rz, 'country': country, 'cnt': 1 });
					}
					//Resort the array
					app.$options.rz = app.$options.rz.sort((a,b) => b.cnt - a.cnt);
					
					//Show links
					if (data) {
						$links.show();
						var foundId = "found-wrong-doing-"+data.id;
						if ($table.find('#'+foundId).length == 0) {
							var html = "<tr id='" + foundId + "'>" +
								"<td><a href='"+data.linkShow+"' target='_blank'>" + data.uid + "</a> <br class='visible-xs'>(" + rz + ")</td>" +
								"<td>" + data.place + "<br>" + data.time + "</td>" +
								"<td class='text-right'>" +
								"<button type='button' data-link='" + data.linkAssign + "' class='btn btn-sm btn-warning js-assign-images'>Přesunout " +
								"<i class='fa fa-share'></i></button>" +
								"</td></tr>";
							$table.append($(html));
						}
					}
				});
			}
		},
		
		removePhoto: function ($button) {
			var app = this,
				$wrapper = $button.closest('.js-added-photo'),
				lang = $Lang;

			$wrapper.addClass('loading');
			
			bootbox.confirm({
			    message: lang.wrongDoings.imageRemoveConfirm,
			    buttons: {
			        confirm: {
			            label: lang.common.yes,
			            className: 'btn-success'
			        },
			        cancel: {
			            label: lang.common.no,
			            className: 'btn-danger'
			        }
			    },
			    callback: function (result) {
			        if (result)
		        	{
		        		if ($button.attr('id')) {
							$.ajax({
								url: route('wrongDoings.deleteImage', {}),
								method: 'delete',
								data: {
									id: $button.attr('id').substr(4),
								},
								success: function (response) {
									$wrapper.removeClass('loading');
									if (!('success' in response) || !response.success) {
										if ('message' in response) {
											bootbox.alert(response.message);
										}
									} else {
										$wrapper.remove();
									}
								},
								error: function (e) {
									console.log('error', e);
									$wrapper.removeClass('loading');
								},
							});
						}
						$wrapper.remove();
		        	}
			    }
			});
		},
		
		toggleDisplayOnAnnouncement: function ($elem) {
			var $input = $($elem.data('id')),
				$checkboxIcon = $elem.find('.checkbox-wrapper');
			if ($input.val() == "1")
			{
				$input.val("0").trigger('change');
				$checkboxIcon.html('<i class="fa fa-square"></i>');
			}
			else
			{
				$input.val("1").trigger('change');
				$checkboxIcon.html('<i class="fa fa-check-square"></i>');
			}
		},

		assignImages: function($button) {
			var app = this;
			$.ajax({
				url: $button.data('link'),
				method: 'post',
				data: null,
				success: function (response) {
					if ('message' in response) {
						bootbox.alert(response.message);
					}
					if (('success' in response) && response.success && ('redirect' in response)) {
						window.setTimeout( function () {
							window.location.href = response.redirect
						}, 1000);
					}
				},
				error: function (e) {
					console.log('error', e);
					bootbox.alert(e);
				},
			});
		},
		
		//=====================================================================
		// Files
		//=====================================================================

		addFile: function ()
		{
			var $template = $('#addedFileTemplate').clone(),
				$addedFilesDiv = $('#addedFiles'),
				index = parseInt($addedFilesDiv.data('index')),
				id = "file" + index,
				app = this;

			$template.attr('id', 'div'+id);
			$template.removeClass('template');

			var templateHtml = $template.html();
			templateHtml = templateHtml.replace(/\{\{id\}\}/g, id);
			$template.html(templateHtml);

			$addedFilesDiv.append($template);
			$addedFilesDiv.data('index', (index + 1));

			var $input = $template.find('input.add-file-input');

			app.$options.imageLoading = true;
			$('#' + id).trigger('click');

			$(document).on('focus', 'body', function () {
				window.setTimeout( function () {
					if (app.$options.imageLoading) {
						app.previewFile($input);
					}
				}, 1000);
			});
		},

		previewFile: function ($input) {
			var app = this,
				imgId = $input.attr('id'),
				$wrapper = $('#div' + imgId),
				files = $input.prop('files');
			app.$options.imageLoading = false;

			if (files && (files.length > 0)) {
				for (var i = 0; i < files.length; ++i)
				{
					const ext = files[i].name.split(/[\.]+/).pop().toLowerCase();
					$wrapper.find('span.document-name').text(files[i].name);
					$wrapper.find('span.document-type').addClass("type-" + ext);
				}
			}
			else
			{
				$input.closest('.js-added-file').remove();
			}

			$(document).off('focus', 'body');
		},

		removeFile: function ($button) {
			var app = this,
				$wrapper = $button.closest('.js-added-file'),
				lang = $Lang;

			bootbox.confirm({
				message: lang.wrongDoings.fileRemoveConfirm,
				buttons: {
					confirm: {
						label: lang.common.yes,
						className: 'btn-success'
					},
					cancel: {
						label: lang.common.no,
						className: 'btn-danger'
					}
				},
				callback: function (result) {
					if (result)
					{
						if ($button.hasClass('js-is-saved'))
						{
							var fileId = $button.attr('id').replace('file-', ''),
								html = "<input type='hidden' name='removed_files[]' value='"+fileId+"'>";
							$('#removedFiles').append(html);
						}
						$wrapper.remove();
					}
				}
			});
		},
		
		//=====================================================================
		
		getRZ: function() {
			return this.$options.rz;
		},
		
		//=====================================================================

		/**
		 * HANDLE BUTTONS
		 */
		handleButtons: function() {
			var app = this,
				$document = $(document);

			$document.on('click', ".js-add-photo", function () {
				app.addPhoto(true);
			});

			$document.on('click', ".js-add-image", function () {
				app.addPhoto(false);
			});

			$document.on('click', ".js-add-file", function () {
				app.addFile(false);
			});

			$document.on('change', ".add-image-input", function () {
				var $input = $(this),
					$wrapper = $input.closest(".js-added-photo");
				app.uploadImage($wrapper, $input);
			});

			$document.on('click', '.js-remove-image', function () {
				app.removePhoto($(this));
			});

			$document.on('change', ".add-file-input", function () {
				app.previewFile($(this));
			});
			$document.on('click', '.js-remove-file', function () {
				app.removeFile($(this));
			});

			$document.on('click', 'button.js-assign-images', function (e) {
				e.preventDefault();
				app.assignImages($(this));
			});

			//TODO povolit pouze pokud je prestupek/event v rezimu editace
			$document.on('click', '.js-change-display-on-announcement', function () {
				app.toggleDisplayOnAnnouncement($(this));
			});
		},

		_init: function () {
			var $controlsDiv = $('div#js-controls-data');
			
			this.$options.sessionId = $('#input_session_id').val();
			this.$options.resourceId = $controlsDiv.data('resourceId');
			this.$options.resourceType = $controlsDiv.data('resourceType');

			this.handleButtons();
		},
	});

})(jQuery);

